import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_7 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_12 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_16 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_27 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_31 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_37 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_40 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_41 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_44 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_45 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = {
  key: 0,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_48 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_49 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_53 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_54 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_55 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_56 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_57 = {
  value: null,
  key: -1
}
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_60 = { class: "col-12" }
const _hoisted_61 = { class: "form-check form-group form-switch mb-25 mt-15" }
const _hoisted_62 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "is_registration_enabled"
}
const _hoisted_63 = {
  key: 1,
  class: "col-12"
}
const _hoisted_64 = {
  key: 2,
  class: "col-md-12"
}
const _hoisted_65 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_66 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_68 = { class: "position-relative" }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_71 = { class: "row justify-content-center" }
const _hoisted_72 = { class: "col" }
const _hoisted_73 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_select = _resolveComponent("country-select")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" NAME "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('form.organization.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.center.name) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.name }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.center.name]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.name ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.name, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_8,
            _createCommentVNode(" DEPARTMENT "),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('form.department.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.center.department) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.department }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.center.department]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.department ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.department, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" MAIN_CONTRACTOR "),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('form.main_contractor.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.center.main_contractor) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.main_contractor }]])
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.center.main_contractor]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.main_contractor ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.main_contractor, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" CONTANCT "),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.$t('form.section.department_information')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" EMAIL "),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('form.email.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.center.email) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.email }]]),
                  pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                  required: "",
                  placeholder: _ctx.$t('form.email.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_22), [
                  [_vModelText, _ctx.center.email]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.email ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.email, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" PHONE_NUMBER "),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.center.phone) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.phone }]])
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.center.phone]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.emphoneail ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.phone, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" WEBSITE "),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('form.website.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.center.website) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.phwebsiteone }]])
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.center.website]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.website ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.website, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" LOCATION "),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h4", _hoisted_33, _toDisplayString(_ctx.$t('form.section.location')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" ADDRESS "),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('form.address.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.center.address) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.address }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.center.address]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.address ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.address, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" ZIP_CODE "),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('form.zip_code.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.center.zip_code) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.zip_code }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.center.zip_code]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.zip_code ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.zip_code, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" COUNTRY "),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('form.country.label')) + "* ", 1 /* TEXT */),
                _createVNode(_component_country_select, {
                  modelValue: _ctx.center.country,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.center.country) = $event)),
                  country: _ctx.center.country,
                  class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.country }]]),
                  required: ""
                }, null, 8 /* PROPS */, ["modelValue", "country", "class"]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.country ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.country, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" LANG "),
            _createElementVNode("div", _hoisted_46, [
              (_ctx.locales.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('feature.contents.lang')), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_49, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select shadow-none text-black pe-50 fs-14 fw-medium w-auto",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.center.def_language_code) = $event)),
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeLang())),
                        required: "",
                        disabled: _ctx.disableLangSelect
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (locale) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: locale,
                            key: locale
                          }, _toDisplayString(_ctx.$t(`feature.contents.$lang.${locale}`)), 9 /* TEXT, PROPS */, _hoisted_51))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_50), [
                        [_vModelSelect, _ctx.center.def_language_code]
                      ])
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.errors?.lang ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.lang, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" ZONE "),
            (_ctx.zones && _ctx.zones.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('feature.roles.zone')), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_56, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["form-select shadow-none text-black pe-50 fs-14 fw-medium", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.zone_id }]]),
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.center.zone_id) = $event)),
                        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeLang(_ctx.zones.find((z) => z.id === _ctx.center.zone_id)?.language_code)))
                      }, [
                        (_openBlock(), _createElementBlock("option", _hoisted_57, _toDisplayString(), 1 /* TEXT */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zones, (zone) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: zone.id,
                            key: zone.id!
                          }, _toDisplayString(zone.name), 9 /* TEXT, PROPS */, _hoisted_58))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 34 /* CLASS, NEED_HYDRATION */), [
                        [_vModelSelect, _ctx.center.zone_id]
                      ])
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.errors?.zone_id ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.zone_id, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" REGISTRATION ENABLED "),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input shadow-none me-8",
                  type: "checkbox",
                  role: "switch",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.center.is_registration_enabled) = $event)),
                  id: "is_registration_enabled"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.center.is_registration_enabled]
                ]),
                _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t('form.is_registration_enabled.label')), 1 /* TEXT */)
              ])
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createCommentVNode(" DELETE "),
                    (_ctx.update)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_66, [
                          _hoisted_67,
                          _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('cta.delete_center')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_69)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_DiscardButton, {
                        onConfirm: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$router.push({ path: _ctx.update ? `/center/${(_ctx.center as CenterInfo).id!}` : '/system-centers' })))
                      }),
                      _createElementVNode("button", {
                        class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                        type: "submit",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submitted = true))
                      }, _toDisplayString(_ctx.$t('cta.save_center')), 1 /* TEXT */)
                    ])
                  ])
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_71, [
      _createElementVNode("div", _hoisted_72, [
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[18] || (_cache[18] = ($event: any) => (_ctx.deleteCenter())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}